import { Container, Flex, Spinner } from "@chakra-ui/react";

const Loading = () => {
  return (
    <Container maxW="5xl" py={12}>
      <Container maxW="5xl" px={4}>
        <Flex
          justify="center"
          align="center"
          w="auto"
          dir="row"
          wrap="wrap"
          gap={3}
        >
          <Spinner size="xl" />
        </Flex>
      </Container>
    </Container>
  );
};

export default Loading;
